import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { greateAmericanTypeOfOperationCourier, typeOfOperationList } from '../../constants/greateAmerican';
export var useQuoteGreatAmericanFieldDisplay = function useQuoteGreatAmericanFieldDisplay() {
  var _ref = useFormContext() || {},
      watch = _ref.watch;

  var _useState = useState(false),
      isFastTrack = _useState[0],
      setIsFastTrack = _useState[1];

  var _useState2 = useState(false),
      showEnterCustomerHouseCarryHeavyItems = _useState2[0],
      setShowEnterCustomerHouseCarryHeavyItems = _useState2[1];

  var _useState3 = useState(false),
      showUseWhatCar = _useState3[0],
      setShowUseWhatCar = _useState3[1];

  var _useState4 = useState(false),
      showMixedCourierWork = _useState4[0],
      setShowMixedCourierWork = _useState4[1];

  var _useState5 = useState(false),
      showWhatTypeOfCommodities = _useState5[0],
      setShowWhatTypeOfCommodities = _useState5[1];

  var _useState6 = useState(false),
      showSubhaulerIndemnify = _useState6[0],
      setShowSubhaulerIndemnify = _useState6[1];

  var _useState7 = useState(false),
      showHowManyCargoLosses = _useState7[0],
      setShowHowManyCargoLosses = _useState7[1];

  var _useState8 = useState(false),
      showDriversAgeRangeAcceptableDot = _useState8[0],
      setShowDriversAgeRangeAcceptableDot = _useState8[1];
  /**
   * watch
   */


  var flowModeWatch = watch('flowMode');
  var declarationQuestionsWatch = watch('declarationQuestions');
  var typeOfRemovalJobWatch = watch('typeOfOperation');
  /**
   * effects
   */

  useEffect(function () {
    var _declarationQuestions, _declarationQuestions2, _declarationQuestions3, _declarationQuestions4, _declarationQuestions5, _declarationQuestions6, _declarationQuestions7;

    var isFast = (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions = declarationQuestionsWatch['great_american_fast_process_criteria']) === null || _declarationQuestions === void 0 ? void 0 : _declarationQuestions.truelyValue) === true;
    var typeOfOperationIsNotInOther = !!typeOfOperationList.find(function (item) {
      return item.value === typeOfRemovalJobWatch;
    });
    !isFastTrack && typeOfRemovalJobWatch && (!typeOfOperationIsNotInOther || typeOfOperationIsNotInOther && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions2 = declarationQuestionsWatch.greate_american_mixed_courier_work) === null || _declarationQuestions2 === void 0 ? void 0 : _declarationQuestions2.truelyValue) === true);
    setIsFastTrack(isFast);
    setShowEnterCustomerHouseCarryHeavyItems(isFast && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions3 = declarationQuestionsWatch.enter_customer_house) === null || _declarationQuestions3 === void 0 ? void 0 : _declarationQuestions3.truelyValue) === true);
    setShowUseWhatCar(!isFast && typeOfRemovalJobWatch === greateAmericanTypeOfOperationCourier);
    setShowMixedCourierWork(!isFast && !!typeOfRemovalJobWatch && typeOfOperationIsNotInOther);
    setShowWhatTypeOfCommodities(!isFast && !!typeOfRemovalJobWatch && (!typeOfOperationIsNotInOther || typeOfOperationIsNotInOther && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions4 = declarationQuestionsWatch.greate_american_mixed_courier_work) === null || _declarationQuestions4 === void 0 ? void 0 : _declarationQuestions4.truelyValue) === true));
    setShowSubhaulerIndemnify(!isFast && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions5 = declarationQuestionsWatch.greate_american_subhauler) === null || _declarationQuestions5 === void 0 ? void 0 : _declarationQuestions5.truelyValue) === true);
    setShowHowManyCargoLosses((declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions6 = declarationQuestionsWatch.greate_american_cargo_loses) === null || _declarationQuestions6 === void 0 ? void 0 : _declarationQuestions6.truelyValue) === true);
    setShowDriversAgeRangeAcceptableDot(!isFast && (declarationQuestionsWatch === null || declarationQuestionsWatch === void 0 ? void 0 : (_declarationQuestions7 = declarationQuestionsWatch.greate_american_drivers_age_range) === null || _declarationQuestions7 === void 0 ? void 0 : _declarationQuestions7.truelyValue) === false);
  }, [flowModeWatch, declarationQuestionsWatch, typeOfRemovalJobWatch]);
  return {
    isFastTrack: isFastTrack,
    showEnterCustomerHouseCarryHeavyItems: showEnterCustomerHouseCarryHeavyItems,
    showUseWhatCar: showUseWhatCar,
    showMixedCourierWork: showMixedCourierWork,
    showWhatTypeOfCommodities: showWhatTypeOfCommodities,
    showSubhaulerIndemnify: showSubhaulerIndemnify,
    showHowManyCargoLosses: showHowManyCargoLosses,
    showDriversAgeRangeAcceptableDot: showDriversAgeRangeAcceptableDot
  };
};